var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.98667C10.78 3.76667 8.54667 3.65334 6.32 3.65334C5 3.65334 3.68 3.72 2.36 3.85334L1 3.98667",
    stroke: "#4D7C79",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 3.31333L4.81335 2.44C4.92002 1.80666 5.00002 1.33333 6.12669 1.33333H7.87335C9.00002 1.33333 9.08669 1.83333 9.18669 2.44666L9.33335 3.31333",
    stroke: "#4D7C79",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5667 6.09332L11.1334 12.8067C11.06 13.8533 11 14.6667 9.14002 14.6667H4.86002C3.00002 14.6667 2.94002 13.8533 2.86668 12.8067L2.43335 6.09332",
    stroke: "#4D7C79",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88666 11H8.10666",
    stroke: "#4D7C79",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 8.33333H8.66665",
    stroke: "#4D7C79",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashPrimary);
export default __webpack_public_path__ + "static/media/trash-primary.645609db76474dbed9b4fb52ca8f512f.svg";
export { ForwardRef as ReactComponent };